import { RequestKind, boolean, string } from '@sb/library/base';
import { AttendanceNoteTemplateDisplayItem, AttendanceNoteTemplateInputItem, AttendanceNoteTemplateSearchOptions, AttendanceNoteTemplateUpdateItem, DisplayItemCollection } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace AttendanceNoteTemplateRoutes {
    export const Search = ApiRoute.Define({
        URL: `search/attendancenotetemplates`,
        Kind: RequestKind.Post,
        PagingAllowed: true,
        BodyType: AttendanceNoteTemplateSearchOptions,
        ResultType: DisplayItemCollection<AttendanceNoteTemplateDisplayItem>
    });

    export const Delete = ApiRoute.Define({
        URL: (templateID: string) => `attendancenotetemplates/${templateID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Update = ApiRoute.Define({
        URL: (templateID: string) => `attendancenotetemplates/${templateID}`,
        Kind: RequestKind.Put,
        BodyType: AttendanceNoteTemplateUpdateItem,
        ResultType: boolean
    });

    export const Add = ApiRoute.Define({
        URL: `attendancenotetemplates`,
        Kind: RequestKind.Post,
        BodyType: AttendanceNoteTemplateInputItem,
        ResultType: string
    });

    export const Get = ApiRoute.Define({
        URL: (attendanceNoteTemplateID: string) => `attendancenotetemplates/${attendanceNoteTemplateID}`,
        Kind: RequestKind.Get,
        ResultType: AttendanceNoteTemplateDisplayItem
    });
}
